import Container, {ContainerProps} from '@mui/material/Container';
import {styled} from '@mui/material/styles';

export const CContainer = styled(Container)<ContainerProps>(
  (/* { theme } */) => ({
  }),
);